import { render, staticRenderFns } from "./information2.vue?vue&type=template&id=05fe69e8&scoped=true"
import script from "./information2.vue?vue&type=script&lang=js"
export * from "./information2.vue?vue&type=script&lang=js"
import style0 from "./information2.vue?vue&type=style&index=0&id=05fe69e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe69e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fe69e8')) {
      api.createRecord('05fe69e8', component.options)
    } else {
      api.reload('05fe69e8', component.options)
    }
    module.hot.accept("./information2.vue?vue&type=template&id=05fe69e8&scoped=true", function () {
      api.rerender('05fe69e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/information2.vue"
export default component.exports